import { ASSET_ICONS, UNKNOWN_KEY } from "@/config";

export function getIconByAsset(asset: string) {
  const iconSrc = ASSET_ICONS[asset];

  if (!iconSrc) {
    return ASSET_ICONS[UNKNOWN_KEY];
  }

  return iconSrc;
}
